var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 352.15,
    height: 73.412,
    viewBox: "0 0 352.15 73.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ba4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003f88"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    d: "M420.754,88.9A36.645,36.645,0,0,0,384.4,121.187c-.016,0-.023-.01-.04-.007-50.43,4.045-200.4,4.419-259.665.612a10.069,10.069,0,1,0-.01,7.673c67.283-3.856,201.619-3.463,259.678.6.02,0,.023-.01.04-.01A36.667,36.667,0,1,0,420.754,88.9Z",
    transform: "translate(-105.308 -88.898)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadRounded);
export default __webpack_public_path__ + "static/media/road-rounded.5a64310b83374fca53abeef94786fb2c.svg";
export { ForwardRef as ReactComponent };